import React, {useState, useRef, useEffect} from 'react';
import post from '../utils/post.js';
import FormTextArea from './FormTextArea.js';
import FormText from './FormText.js';
import usePopupAnimation from '../utils/usePopupAnimation.js';

export default function NoteNew({showNew, closeNew, updateNoteRowNew}) {
	const popupAnimationMs = 300;
	const [loading, setLoading] = useState(false);
	const [name, setName] = useState('');
	const [note, setNote] = useState('');
	const [sortorder, setSortorder] = useState(1);
	const [sortorderError, setSortorderError] = useState('');
	const [noteError, setNoteError] = useState('');
	const [nameError, setNameError] = useState('');

	const nameRef = useRef(null);
	const noteRef = useRef(null);
	const sortorderRef = useRef(null);
	const {shouldRender, isClosing} = usePopupAnimation(showNew, popupAnimationMs);

	useEffect(() => {
		setNote('');
		setName('');
		setSortorder(1);
		setSortorderError('');
		setNoteError('');
		setNameError('');
	}, [showNew]);

	const handleSubmit = (e) => {
		e.preventDefault();

		setNoteError('');
		setNameError('');
		setSortorderError('');

		let localError = 0;

		if (!note) {
			localError = 1;
			setNoteError('povinné');
			noteRef.current.focus();
		}

		if (!name) {
			localError = 1;
			setNameError('povinné');
			nameRef.current.focus();
		}

		if (localError === 0) {
			setLoading(true);

			post('saveNoteNew', {SORTORDER: sortorder, NAME: name, NOTE: note})
				.then((res) => {
					closeNew();

					if (res.ID > 0) {
						updateNoteRowNew({ID: res.ID, CRDTS: res.CRDTS, SORTORDER: sortorder, NAME: name, NOTE: note, NOTES: res.NOTES});
					}

					setLoading(false);
				})
				.catch((error) => {
					console.error(error);
					setLoading(false);
				});
		}
	};

	return (
		<>
			{shouldRender ? (
				<div className={`popup${isClosing ? ' popup--closing' : ''}`}>
					<div className={`popup_content${isClosing ? ' popup_content--closing' : ''}`}>
						<form method="POST" onSubmit={handleSubmit}>
							<div className="popup_content_in_head">
								<div className="popup_content_in_head_in">Nová poznámka</div>
								<img
									alt=""
									className="popup_content_in_head_in-close"
									onClick={() => {
										closeNew();
									}}
								/>
							</div>
							<div className="popup_content_in_body">
								<div className="popup_content_in_body_in">
									<div className="fl_l" style={{width: '48%'}}>
										<FormText type="text" label="Pořadí" value={sortorder} setValue={setSortorder} ref={sortorderRef} error={sortorderError} />
									</div>
									<div className="fl_r" style={{width: '48%'}}>
										
									</div>
									<div className="zero h0" />

									<FormText type="text" label="Název" value={name} setValue={setName} ref={nameRef} error={nameError} />
									<div className="zero h0" />

									<FormTextArea type="text" label="Poznámka" height="25rem" value={note} setValue={setNote} ref={noteRef} error={noteError} />
									<div className="zero h0" />
								</div>
							</div>
							<div className="popup_content_in_foot">
								<div className="popup_content_in_foot_in">
									<input type="submit" name="button_save" value="Uložit" className="button green mr_2" disabled={loading} />
									<button
										type="button"
										className="button"
										onClick={() => {
											closeNew();
										}}
									>
										Zpět
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			) : (
				''
			)}
		</>
	);
}
